//import * as timeago from 'timeago.js';

class ProjectListComponent extends HTMLElement {

  constructor() {
    super();
    document.addEventListener('projects-loaded', (event) => this.onUpdate(event.detail), true)
    document.addEventListener('project-loaded', (event) => this.onProjectLoaded(event.detail), true)
    document.addEventListener('customer-logged-in', () => this.onLogin(), true)
    document.addEventListener('customer-logged-out', () => this.onLogout(), true)
    document.addEventListener('customer-logged-in-and-upgraded', () => this.onLoggedInAndUpgraded(), true)
    document.addEventListener('customer-logged-in-not-upgraded', () => this.onLoggedInNotUpgraded(), true)
  }

  onProjectLoaded(project) {
    document.getElementById("active-project-title").innerHTML = project.title
    document.getElementById("active-project-shape").innerHTML = project.shapeName
    document.getElementById("active-project-design-spec").innerHTML = project.designTypeStr
  }

  onLogout() {
    document.getElementById('upgrade-list-item').classList.remove('d-none')
    document.getElementById('finish-upgrade-list-item').classList.add('d-none')
    document.getElementById('project-list').innerHTML = ''
    document.getElementById('project-list').classList.add('d-none')
  }

  onLogin() {
    document.getElementById('project-list').classList.remove('d-none')
    document.getElementById('projects-loading-spinner').classList.remove('d-none')
  }

  onLoggedInAndUpgraded() {
    document.getElementById('project-list').classList.remove('d-none')
    document.getElementById('upgrade-list-item').classList.add('d-none')
    document.getElementById('finish-upgrade-list-item').classList.add('d-none')
    document.getElementById('projects-loading-spinner').classList.add('d-none')
  }

  onLoggedInNotUpgraded() {
    document.getElementById('upgrade-list-item').classList.add('d-none')
    document.getElementById('finish-upgrade-list-item').classList.remove('d-none')
    document.getElementById('project-list').innerHTML = ''
    document.getElementById('project-list').classList.add('d-none')
    document.getElementById('projects-loading-spinner').classList.add('d-none')
  }

  onUpdate(projects) {
    console.log('update')
    let str = ''
    projects.forEach( (project) => {
      if(project.isActive === false) {
        str += String.raw`
        <div class="list-group py-1">
          <a href="#" id="project-${project.key}" class="link-dark rounded ${project.isActive ? 'fw-bold' : ''}">
            <div class="list-group-item py-1">
              <div>
                <i class="fa fa-fw fa-file-o"></i>${project.title}
              </div>
              <div>
                <small>${project.shapeName} ${project.designTypeStr}</small>
              </div>
              <div class="text-muted small">
                ${timeago.format(project.createdAt)}
              </div>
            </div>
          </a>
        </div>
        `
      } else {
        document.getElementById("active-project-title").innerHTML = project.title
        document.getElementById("active-project-shape").innerHTML = project.shapeName
        document.getElementById("active-project-design-spec").innerHTML = project.designTypeStr
      }
    })

    document.getElementById('project-list').innerHTML = str

    projects.forEach((project) => {
      if(project.isActive === false) {
        document.getElementById(`project-${project.key}`).onclick = () => {
          let event = new CustomEvent('load-project', { detail: project });
          document.dispatchEvent(event)
        }
      }
    })
  }

  connectedCallback() {
    this.innerHTML = String.raw`
    <style>
      .b-example-divider {
        flex-shrink: 0;
        width: 0.5rem;
        height: 100vh;
        
      }
    </style>

      <div class="d-flex flex-column align-items-stretch flex-shrink-0" style="width: 240px; ">

        <div class="list-group py-1">
          <a href="#" class="list-group-item" id="project-list-new-design">
            <div class="text-success">
              <b>New Beam Design</b>
              <i class="fa fa-fw fa-file-o pull-right"></i>
            </div>
          </a>

          <div id="current-project-item" class="list-group-item">
            <strong>
              <span id="active-project-title">Untitled Beam</span>
            </strong>
            <div>
              <strong><small>
                  <span id="active-project-shape">W8X15</span>
                  <span id="active-project-design-spec">AISC Steel LRFD</span>
                </small>
              </strong>
            </div>
          </div>
        </div>
        
        <!-- spinner -->
        <div class="list-group py-1 d-none" id="projects-loading-spinner" >
          <div class="list-group-item">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Loading...
          </div>
        </div>
      
        <div class="list-group py-1 d-none" id="upgrade-list-item" >
          <a href="#" class="list-group-item" data-bs-toggle="modal" data-bs-target="#modal-sign-up-form">
            <h4 class="text-success">
              <strong>Print</strong> and <strong>Save</strong> projects
            </h4>
            <p class="text-success">
              Upgrade for $19 monthly
            </p>
            <a href="#" class="btn btn-lg btn-success btn-block button-shadow" data-bs-toggle="modal" 
            data-bs-target="#modal-sign-up-form" >Upgrade</a>
          </a>
        </div>
      
        <div class="list-group py-1 d-none" id="finish-upgrade-list-item">
          <a href="#" class="btn btn-lg btn-success btn-block button-shadow" data-bs-toggle="modal" data-bs-target="#modal-finish-upgrade">
            Start Subscription
          </a>
        </div>

        <div class="list-group py-1 d-none" id="renew-subscription-list-item">
          <a href="#" data-bs-toggle="modal" data-bs-target="#modal-finish-upgrade" class="btn btn-lg btn-success btn-block button-shadow">
            Renew Subscription
          </a>
        </div>
      
        <div class="list-group2" id="project-list"></div>

      </div>
      `
  }
}

customElements.define('project-list-component', ProjectListComponent);